import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEO, { createWebPageSchema, createBreadcrumbSchema, createOrganizationSchema } from '../../components/feature/SEO';

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://unqcode.com';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = isRTL ? [
    {
      title: 'المعلومات التي نجمعها',
      content: [
        'المعلومات التي تقدمها مباشرةً: عند تعبئة نماذج التواصل أو طلبات التوظيف أو الاشتراك في خدماتنا، نجمع: الاسم الكامل، عنوان البريد الإلكتروني، رقم الهاتف، اسم الشركة، ومعلومات المشروع.',
        'المعلومات التي نجمعها تلقائياً: عند زيارة موقعنا، نجمع بيانات مثل: عنوان IP، نوع المتصفح، الصفحات التي زرتها، وقت الزيارة، وبيانات مشابهة عبر ملفات تعريف الارتباط وتقنيات التتبع.',
        'البيانات الاختيارية: أي معلومات إضافية تختار مشاركتها معنا في المراسلات أو الاجتماعات أو عبر منصات التواصل الاجتماعي.',
      ],
    },
    {
      title: 'كيف نستخدم معلوماتك',
      content: [
        'للرد على استفساراتك وطلباتك وتقديم الخدمات التي طلبتها.',
        'لإرسال تحديثات تقنية، أخبار، ومعلومات تتعلق بالخدمات التي اشتركت فيها (مع إمكانية إلغاء الاشتراك في أي وقت).',
        'لتحسين موقعنا وخدماتنا من خلال تحليل أنماط الاستخدام وآراء المستخدمين.',
        'للامتثال للالتزامات القانونية والتنظيمية المطبقة.',
        'لحماية حقوقنا وحقوق مستخدمينا من الاحتيال أو إساءة الاستخدام.',
      ],
    },
    {
      title: 'مشاركة المعلومات',
      content: [
        'لا نبيع بياناتك الشخصية لأطراف ثالثة في أي حال من الأحوال.',
        'قد نشارك بياناتك مع موردي الخدمات الموثوقين الذين يساعدوننا في تقديم خدماتنا (مثل مزودي الاستضافة، خدمات البريد الإلكتروني) وذلك بموجب اتفاقيات سرية صارمة.',
        'قد نفصح عن معلوماتك إذا طُلب ذلك بموجب القانون أو بأمر من جهة قضائية.',
        'في حال الاندماج أو الاستحواذ، قد تنتقل بياناتك إلى الكيان الجديد مع إخطارك مسبقاً.',
      ],
    },
    {
      title: 'حماية البيانات',
      content: [
        'نستخدم تشفير SSL/TLS لنقل البيانات عبر الإنترنت.',
        'يتم تخزين البيانات الحساسة على خوادم مؤمنة بمعايير مؤسسية.',
        'نراجع ونحدّث إجراءات الأمان بانتظام للحماية من التهديدات.',
        'يقتصر الوصول إلى بياناتك الشخصية على الموظفين الذين يحتاجون إليها لأداء مهامهم.',
      ],
    },
    {
      title: 'حقوقك',
      content: [
        'حق الوصول: يمكنك طلب نسخة من البيانات الشخصية التي نحتفظ بها عنك.',
        'حق التصحيح: يمكنك طلب تصحيح أي بيانات غير دقيقة أو غير مكتملة.',
        'حق الحذف: يمكنك طلب حذف بياناتك الشخصية وفقاً لظروف معينة.',
        'حق الاعتراض: يمكنك الاعتراض على معالجة بياناتك لأغراض تسويقية في أي وقت.',
        'حق النقل: يمكنك طلب استلام بياناتك في صيغة إلكترونية قابلة للقراءة.',
        'لممارسة هذه الحقوق، تواصل معنا عبر: Info@unqcode.com',
      ],
    },
    {
      title: 'ملفات تعريف الارتباط (Cookies)',
      content: [
        'نستخدم ملفات تعريف الارتباط لتحسين تجربة التصفح وتخصيص المحتوى وتحليل حركة المرور.',
        'يمكنك التحكم في ملفات تعريف الارتباط من خلال إعدادات متصفحك، علماً بأن تعطيلها قد يؤثر على بعض وظائف الموقع.',
        'نستخدم ملفات تعريف الارتباط الخاصة بنا وملفات طرف ثالث مثل Google Analytics لفهم كيفية استخدام الموقع.',
      ],
    },
    {
      title: 'الاحتفاظ بالبيانات',
      content: [
        'نحتفظ ببياناتك الشخصية طالما كان ذلك ضرورياً لتقديم خدماتنا أو الوفاء بالتزاماتنا القانونية.',
        'عند انتهاء العلاقة التجارية، نحتفظ بالسجلات الضرورية لمدة 7 سنوات وفقاً لمتطلبات المحاسبة والقانون.',
        'بيانات الاتصال التسويقي تُحذف فور طلب إلغاء الاشتراك.',
      ],
    },
    {
      title: 'التغييرات على السياسة',
      content: [
        'نحتفظ بالحق في تحديث هذه السياسة في أي وقت. سنخطرك بأي تغييرات جوهرية عبر البريد الإلكتروني أو إشعار بارز على موقعنا.',
        'يُعدّ استمرار استخدامك للموقع بعد التغييرات موافقةً ضمنية على السياسة المحدثة.',
        'نوصي بمراجعة هذه الصفحة دورياً للاطلاع على آخر التحديثات.',
      ],
    },
  ] : [
    {
      title: 'Information We Collect',
      content: [
        'Information you provide directly: When filling out contact forms, job applications, or subscribing to our services, we collect: full name, email address, phone number, company name, and project information.',
        'Information collected automatically: When you visit our site, we collect data such as: IP address, browser type, pages visited, visit time, and similar data through cookies and tracking technologies.',
        'Optional data: Any additional information you choose to share with us in correspondence, meetings, or via social media platforms.',
      ],
    },
    {
      title: 'How We Use Your Information',
      content: [
        'To respond to your inquiries and requests, and to provide the services you have requested.',
        'To send technical updates, news, and information related to services you have subscribed to (with the ability to unsubscribe at any time).',
        'To improve our website and services by analyzing usage patterns and user feedback.',
        'To comply with applicable legal and regulatory obligations.',
        'To protect our rights and those of our users from fraud or misuse.',
      ],
    },
    {
      title: 'Information Sharing',
      content: [
        'We do not sell your personal data to third parties under any circumstances.',
        'We may share your data with trusted service providers who help us deliver our services (such as hosting providers, email services) under strict confidentiality agreements.',
        'We may disclose your information if required by law or court order.',
        'In the event of a merger or acquisition, your data may be transferred to the new entity with prior notice to you.',
      ],
    },
    {
      title: 'Data Protection',
      content: [
        'We use SSL/TLS encryption for data transmission over the internet.',
        'Sensitive data is stored on servers secured with enterprise-grade standards.',
        'We regularly review and update security procedures to protect against threats.',
        'Access to your personal data is limited to employees who need it to perform their duties.',
      ],
    },
    {
      title: 'Your Rights',
      content: [
        'Right of Access: You can request a copy of the personal data we hold about you.',
        'Right of Rectification: You can request correction of any inaccurate or incomplete data.',
        'Right of Erasure: You can request deletion of your personal data under certain circumstances.',
        'Right to Object: You can object to the processing of your data for marketing purposes at any time.',
        'Right to Portability: You can request to receive your data in a machine-readable electronic format.',
        'To exercise these rights, contact us at: Info@unqcode.com',
      ],
    },
    {
      title: 'Cookies',
      content: [
        'We use cookies to improve the browsing experience, personalize content, and analyze traffic.',
        'You can control cookies through your browser settings, but disabling them may affect some website functionality.',
        'We use our own cookies and third-party cookies such as Google Analytics to understand how the site is used.',
      ],
    },
    {
      title: 'Data Retention',
      content: [
        'We retain your personal data for as long as necessary to provide our services or fulfill our legal obligations.',
        'After the business relationship ends, we retain necessary records for 7 years in accordance with accounting and legal requirements.',
        'Marketing contact data is deleted immediately upon unsubscribe request.',
      ],
    },
    {
      title: 'Policy Changes',
      content: [
        'We reserve the right to update this policy at any time. We will notify you of any material changes via email or a prominent notice on our website.',
        'Your continued use of the site after changes constitutes implicit acceptance of the updated policy.',
        'We recommend reviewing this page periodically for the latest updates.',
      ],
    },
  ];

  return (
    <div className={`min-h-screen bg-white ${isRTL ? 'font-arabic' : ''}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <SEO
        title={t('seo.privacyTitle')}
        description={t('seo.privacyDesc')}
        keywords="privacy policy, data protection, GDPR, personal data, سياسة الخصوصية, حماية البيانات"
        canonical={`${siteUrl}/privacy`}
        ogType="website"
        schema={{
          '@context': 'https://schema.org',
          '@graph': [
            createWebPageSchema(
              isRTL ? 'سياسة الخصوصية | الكود المميز - Unique Code' : 'Privacy Policy | Unique Code - الكود المميز',
              isRTL 
                ? 'سياسة الخصوصية لموقع الكود المميز. تعرف على كيفية جمعنا واستخدامنا وحمايتنا لبياناتك الشخصية.' 
                : 'Privacy Policy for Unique Code. Learn how we collect, use, and protect your personal data.',
              '/privacy'
            ),
            createOrganizationSchema(),
            createBreadcrumbSchema([
              { name: 'Home', url: '/' },
              { name: isRTL ? 'سياسة الخصوصية' : 'Privacy Policy', url: '/privacy' },
            ]),
            {
              '@type': 'PrivacyPolicy',
              '@id': `${siteUrl}/privacy#privacypolicy`,
              name: isRTL ? 'سياسة الخصوصية - الكود المميز' : 'Privacy Policy - Unique Code',
              description: isRTL
                ? 'سياسة الخصوصية لموقع الكود المميز. تعرف على كيفية جمعنا واستخدامنا وحمايتنا لبياناتك الشخصية.'
                : 'Privacy Policy for Unique Code. Learn how we collect, use, and protect your personal data.',
              url: `${siteUrl}/privacy`,
              datePublished: '2025-03-01',
              dateModified: '2025-03-01',
              inLanguage: ['en', 'ar'],
              publisher: {
                '@id': `${siteUrl}/#organization`,
              },
              isPartOf: {
                '@id': `${siteUrl}/#website`,
              },
            },
          ],
        }}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 bg-gray-950 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/dcca311fd063094d0a96b35da7b316c2.jpg"
            alt="background"
            className="w-full h-full object-cover object-top opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-gray-950/80 to-gray-950"></div>
        </div>
        <div className="relative max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-red/20 border border-brand-red/30 rounded-full text-brand-red text-sm font-semibold mb-6">
            <i className="ri-shield-check-line text-sm"></i>
            {isRTL ? 'الخصوصية والأمان' : 'Privacy & Security'}
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
            {isRTL ? 'سياسة الخصوصية' : 'Privacy Policy'}
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            {isRTL
              ? 'نلتزم بحماية خصوصيتك وأمان بياناتك الشخصية. اقرأ هذه السياسة لفهم كيف نجمع معلوماتك ونستخدمها ونحميها.'
              : 'We are committed to protecting your privacy and the security of your personal data. Read this policy to understand how we collect, use, and protect your information.'}
          </p>
          <p className="text-gray-500 text-sm mt-4">
            {isRTL ? 'آخر تحديث: مارس 2025' : 'Last updated: March 2025'}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          {/* Intro */}
          <div className="bg-gray-50 rounded-2xl p-8 mb-10 border border-gray-100">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-brand-red/10 rounded-xl flex-shrink-0">
                <i className="ri-information-line text-brand-red text-xl"></i>
              </div>
              <div>
                <h2 className="font-bold text-gray-900 text-lg mb-2">
                  {isRTL ? 'نظرة عامة' : 'Overview'}
                </h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {isRTL
                    ? 'تُوضّح سياسة الخصوصية هذه كيف تجمع يونيك كود ("نحن" أو "الشركة") المعلومات من مستخدمي موقعنا وعملائنا، وكيف نستخدمها ونشاركها ونحميها. تنطبق هذه السياسة على جميع الخدمات والمنتجات التي تقدمها يونيك كود. بالاستمرار في استخدام موقعنا أو خدماتنا، فإنك تقبل ممارسات الخصوصية الموضحة في هذه الوثيقة.'
                    : 'This Privacy Policy describes how Unique Code ("we" or "the Company") collects, uses, shares, and protects information from users of our website and clients. This policy applies to all services and products provided by Unique Code. By continuing to use our website or services, you accept the privacy practices outlined in this document.'}
                </p>
              </div>
            </div>
          </div>

          {/* Table of Contents */}
          <div className="bg-white rounded-2xl border border-gray-100 p-6 mb-10">
            <h3 className="font-bold text-gray-900 mb-4 text-sm uppercase tracking-wide">
              {isRTL ? 'المحتويات' : 'Table of Contents'}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {sections.map((section, idx) => (
                <a
                  key={idx}
                  href={`#section-${idx}`}
                  className="flex items-center gap-2 text-sm text-gray-600 hover:text-brand-red transition-colors cursor-pointer py-1"
                >
                  <span className="w-5 h-5 flex items-center justify-center bg-brand-red/10 text-brand-red rounded-full text-xs font-bold flex-shrink-0">
                    {idx + 1}
                  </span>
                  {section.title}
                </a>
              ))}
            </div>
          </div>

          {/* Sections */}
          <div className="space-y-10">
            {sections.map((section, idx) => (
              <div key={idx} id={`section-${idx}`} className="scroll-mt-24">
                <div className="flex items-center gap-3 mb-4">
                  <span className="w-8 h-8 flex items-center justify-center bg-brand-red text-white rounded-lg text-sm font-bold flex-shrink-0">
                    {idx + 1}
                  </span>
                  <h2 className="text-xl font-bold text-gray-900">{section.title}</h2>
                </div>
                <div className="border-r-2 border-brand-red/20 pr-6 mr-4 space-y-3">
                  {section.content.map((item, iIdx) => (
                    <div key={iIdx} className="flex items-start gap-3">
                      <div className="w-1.5 h-1.5 rounded-full bg-brand-red mt-2 flex-shrink-0"></div>
                      <p className="text-gray-600 text-sm leading-relaxed">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Contact box */}
          <div className="mt-16 bg-gray-950 rounded-2xl p-8 text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-brand-red/20 rounded-xl mx-auto mb-4">
              <i className="ri-mail-line text-brand-red text-xl"></i>
            </div>
            <h3 className="text-white font-bold text-xl mb-2">
              {isRTL ? 'هل لديك استفسار؟' : 'Have a Question?'}
            </h3>
            <p className="text-gray-400 text-sm mb-6">
              {isRTL
                ? 'إذا كان لديك أي سؤال حول سياسة الخصوصية أو طريقة تعاملنا مع بياناتك، لا تتردد في التواصل معنا.'
                : "If you have any questions about our Privacy Policy or how we handle your data, don't hesitate to reach out."}
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="mailto:Info@unqcode.com"
                className="inline-flex items-center gap-2 px-6 py-3 bg-brand-red text-white rounded-xl text-sm font-semibold hover:bg-brand-red-dark transition-all cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                Info@unqcode.com
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-6 py-3 border border-gray-700 text-gray-300 rounded-xl text-sm font-semibold hover:border-brand-red hover:text-brand-red transition-all cursor-pointer"
              >
                <i className="ri-message-2-line"></i>
                {isRTL ? 'نموذج التواصل' : 'Contact Form'}
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
